import React from 'react';

const FoodAppIcon: React.FC<{ className?: string }> = ({ className = 'w-full h-full' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path 
      d="M18.06 22.99H5.98C5.7 22.99 5.48 22.76 5.48 22.49C5.48 19.12 8.2 16.4 11.57 16.4C14.94 16.4 17.66 19.12 17.66 22.49C17.66 22.76 17.44 22.99 17.16 22.99H18.06Z" 
      fill="currentColor"
    />
    <path 
      d="M6 16V14H18V16H6Z" 
      fill="currentColor"
    />
    <path 
      d="M6 20V18H18V20H6Z" 
      fill="currentColor"
    />
    <path 
      d="M19 10H5C3.9 10 3 9.1 3 8V5C3 3.9 3.9 3 5 3H19C20.1 3 21 3.9 21 5V8C21 9.1 20.1 10 19 10ZM5 4.5C4.73 4.5 4.5 4.73 4.5 5V8C4.5 8.27 4.73 8.5 5 8.5H19C19.27 8.5 19.5 8.27 19.5 8V5C19.5 4.73 19.27 4.5 19 4.5H5Z" 
      fill="currentColor"
    />
    <path 
      d="M12 14.5C11.17 14.5 10.5 13.83 10.5 13V4.5H13.5V13C13.5 13.83 12.83 14.5 12 14.5Z" 
      fill="currentColor"
    />
  </svg>
);

export default FoodAppIcon;
